import React from "react";
import { Link } from "react-router-dom";
import "./primary-btn.css";

export default function PrimaryBtn({
  isLink,
  text,
  to,
  onClick,
  submit,
  noPadding,
  isIcon,
  ...props
}) {
  let className = `primary-btn btn ${props.className || ""}`;

  if (submit) {
    className = `primary-btn ${props.className || ""}`;
    return (
      <button type="submit" href="#" className={className} onClick={onClick} >
        {text}
      </button>
    );
  }
  if (isLink) {
    return (
      <Link to={to}>
        <a href="#" className={`primary-btn ${props.className || ""}`}>
          {text}
        </a>
      </Link>
    );
  }
  if (isIcon) {
    return (
      <a onClick={onClick} className={`hide-bg`}>
        {text}
      </a>
    );
  }
  if (noPadding)
    className = `primary-btn btn no-padding ${props.className || ""}`;
  return (
    <a onClick={onClick} className={`primary-btn ${props.className || ""}`}>
      {text}
    </a>
  );
}
